import React, {Component} from 'reactn';
import PaginatedQueryDataGrid from "../../components/PaginatedQueryDataGrid"
import {Button, Col, FormGroup, Row} from "reactstrap";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import i18n from '../../views/Pages/Login/i18n';
import schema from "../../schemas/task-dyce.schema.js"
import 'react-dates/lib/css/_datepicker.css';
import TasksDetail from "../../components/TasksDetail";
import TasksComments from "../../components/TasksComments";
import CreateTask from "../../views/CreateTask";
import {dateFormatter, queryTypeFotmatter} from "../../utils/Formatters";
import {transformSchema} from '../../utils/Helpers';
import {Query} from "react-apollo";
import Loading from "../../components/Loading";
import gql from "graphql-tag";

class Queries extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            showCreateTask: false,
            filters: {
                status: [{id: "Open", label: "Open"}, {id: "In Progress", label: "In Progress"}]
            },
            task: this.props.match && this.props.match.params && this.props.match.params.queryId ? this.props.match.params.queryId : null,
            page: 1,
            tasksPerPage: 10
        };
        this.getMeterPoints = this.getMeterPoints.bind(this);
    }

    toggle() {
        this.setState({
            showCreateTask: !this.state.showCreateTask
        });
    }

    getQueries() {
        const result = {};
        const uiQueries = this.props.configuration.uiQueries;
        for (let i = 0; i < uiQueries.length; i++) {
            result[uiQueries[i].name] = uiQueries[i].query;
        }
        return result;
    }

    getMeterPoints(customer) {
        return customer.flatMap(account => {
            return account.accounts.reduce((acc, properties) => {
                properties.properties.length > 0 &&
                acc.push(properties.properties.flatMap(site => site.site.meterPoints.flatMap(meterPoint => meterPoint.identifier)));

                return acc;
            }, []).flat();
        })
    }

    render() {
        const queries = this.getQueries();
        const includeContentFields = this.props.includeContentFields ? this.props.includeContentFields : null;

        return (
            <div className="manage-users tasks-page">
                <Row className='subheader'>
                    <Col className='col-8'>
                        <h1>Queries</h1>
                    </Col>
                    <Col className='col-4'>
                        {!this.props.hideQueryBtn && <FormGroup>
                            <Button onClick={() => this.setState({showCreateTask: true})} className='pull-right'
                                    color="primary"> <i className="icon ion-plus-round"></i>&nbsp;&nbsp;Add Query
                            </Button>
                        </FormGroup>}
                    </Col>
                </Row>
                <div className="page-cnt">
                    <Row>
                        <Col sm={12}>
                            <PaginatedQueryDataGrid export={true} dataPath={this.props.queryPath + '.content'}
                                                    queryKey={this.props.queryKey} queries={queries}
                                                    paginationPath={this.props.queryPath}
                                                    keyField={'id'}
                                                    note={this.props.note}
                                                    updateKey="listOfTasksQuery"
                                                    defaultSorted={{
                                                        dataField: 'createTime',
                                                        order: 'desc'
                                                    }}
                                                    gridRowClass={'tasks-cnt1 row-eq-height '}
                                                    gridColClass={'tasks-list'}
                                                    gridColSM={this.state.task ? 4 : 12}
                                                    children={this.state.task && <Col sm={8} className="task-details-cnt">
                                                        <TasksDetail
                                                            power={this.props.power}
                                                            task={this.state.task}
                                                            resetView={() => this.setState({task: null})}></TasksDetail>
                                                        <TasksComments
                                                            task={this.state.task}/>
                                                    </Col>}
                                                    variables={this.props.variables ? this.props.variables : ''}
                                                    columns={[
                                                        {
                                                            dataField: 'variables.consumer_number',
                                                            text: "Account Number",
                                                            sort: true
                                                        },
                                                        {
                                                            dataField: 'variables.mprn',
                                                            text: "Meter Point",
                                                            sort: true
                                                        },
                                                        ...(!this.state.task && [{
                                                            dataField: 'variables.type',
                                                            text: 'Type',
                                                            sort: true,
                                                            formatter: function(cell, row) {
                                                                const text = queryTypeFotmatter(cell, row, null, this.props);
                                                                return row.attachmentCount ? (
                                                                    <div><i className="icon ion-android-attach"
                                                                            title={"Attachments"}></i> {text}</div>) : text
                                                            }.bind(this),
                                                            csvformatter: function(cell, row) {
                                                                const text = queryTypeFotmatter(cell, row, null, this.props);
                                                                return row.attachmentCount ? "📎 "+ text : text
                                                            }.bind(this)
                                                        },
                                                            {
                                                                dataField: 'createTime',
                                                                text: 'Date Raised',
                                                                formatter: dateFormatter,
                                                                sort: true
                                                            },
                                                            ...(this.props.queryKey === "MyQueries" && this.props.admin ? [{
                                                                dataField: 'variables.status',
                                                                text: 'Status',
                                                                dropdown: true,
                                                                statuses: ["Open","Closed"],
                                                                mutationKey: "updateTask",
                                                                sort: true
                                                            }]: [{
                                                                dataField: 'variables.status',
                                                                text: 'Status',
                                                                sort: true
                                                            }])
                                                        ])]}
                                                    filters={[
                                                        ...(
                                                            this.props.queryKey === 'QueryByCustomer' && [{
                                                                type: "text",
                                                                fields: ['owner','variables.mprn', 'variables.account_code', 'variables.estate', 'variables.external_id', 'variables.consumer_number', 'description', 'owner'],
                                                                placeholder: `Search by Meter Point/Account Number/Site Name/Query ID/Queries Name`,
                                                                label: 'Search',
                                                                classes: "search",
                                                                cols: 4
                                                            }]
                                                        ),
                                                        ...(
                                                            this.props.queryKey === 'QueryByProperty' && [{
                                                                type: "text",
                                                                fields: ['owner','variables.external_id'],
                                                                placeholder: 'Search by Meter Point or Raised By',
                                                                label: 'Search',
                                                                classes: "search",
                                                                cols: 4
                                                            }]
                                                        ),
                                                        ...(
                                                            this.props.queryKey === 'MyQueries' && [{
                                                                type: "text",
                                                                fields: ["owner", "variables.mprn","variables.account_code","variables.consumer_number"],
                                                                placeholder: `Search by Meter Point/Account Number/Raised By`,
                                                                label: 'Search',
                                                                classes: "search",
                                                                cols: 4
                                                            }]
                                                        ),
                                                        ...(
                                                            this.props.queryKey && [{
                                                                type: "date",
                                                                fields: ["createTime"],
                                                                placeholder: 'Queries raised between dates',
                                                                label: 'Queries raised between dates',
                                                                cols: 4,
                                                                disableFutureDates: true
                                                            }]
                                                        ),
                                                        ...(
                                                            this.props.queryKey && [{
                                                                type: "typeahead",
                                                                fields: ["variables.status"],
                                                                possibleValues: [{key: 'Open', value: 'Open'}, {key: 'Closed', value: 'Closed'}],
                                                                placeholder: i18n.t('tasks.status'),
                                                                label: i18n.t('tasks.status'),
                                                                classes: 'select'
                                                            }]
                                                        ),
                                                        ...(
                                                            this.props.queryKey && [{
                                                                type: "typeahead",
                                                                fields: ["variables.type"],
                                                                enumValues: this.props.power ? transformSchema(schema, 'E').properties.type.anyOf : transformSchema(schema, 'G').properties.type.anyOf,
                                                                placeholder: i18n.t('tasks.type'),
                                                                label: i18n.t('tasks.type'),
                                                                classes: 'select'
                                                            }]
                                                        ),
                                                    ]}
                                                    initialFilters={{'variables.status': "Open"}}
                                                    onSelect={(selected) => {
                                                        this.setState({task: selected})
                                                    }}
                            />
                        </Col>
                        <Query
                            // only run query once user clicks on btn
                            // to open modal
                            skip={!this.state.showCreateTask}
                            query={gql`
                                ${queries[this.props.secondQueryKey]}
                            `}
                            variables={{
                                pageSize: 100,
                                pageNumber: 0,
                                sort: {
                                    orders: [
                                        {
                                            property: "name",
                                            direction: "asc",
                                        },
                                    ],
                                },
                                ...(includeContentFields && includeContentFields),
                                where: null,
                            }}
                        >
                            {({ loading, error, data }) => {
                                if (loading) return <Loading />;
                                if (error) return `Error! ${error.message}`;

                                return data ? (
                                    <CreateTask
                                        modalOpen={this.state.showCreateTask}
                                        onClose={this.toggle}
                                        refetch={this.refetchGrid}
                                        user={this.global.username}
                                        properties={
                                            data.Customer.content.length > 0 &&
                                            data.Customer.content.flatMap((account) =>
                                                account.accounts.filter(
                                                    (properties) => properties.properties.length > 0
                                                )
                                            )
                                        }
                                        meterPointsData={
                                            data.Customer.content.length > 0 &&
                                            data.Customer.content.flatMap((account) =>
                                                account.accounts.flatMap((x) =>
                                                    x["properties"].flatMap((y) => y["site"].meterPoints)
                                                )
                                            )
                                        }
                                        accounts={
                                            data.Customer.content.length > 0 &&
                                            data.Customer.content.flatMap((account) =>
                                                account.accounts.flatMap((x) =>
                                                    this.props.useAccNum ?
                                                        x.number : 
                                                        x["properties"].flatMap((consumerNumber) => consumerNumber.name)
                                                )
                                            )
                                        }
                                    />
                                ) : null;
                            }}
                        </Query>
                    </Row>
                </div>
            </div>
        );
    }
}

export default Queries;
